import { CardContent, Stack, type Theme } from "@mui/material";
import { Card, Text } from "@src/appV2/redesign/system/ui-components";

interface CancellationCreditPenaltySubCardProps {
  title: string;
  pointsWithCredit: number;
  pointsWithoutCredit: number;
  hasCredit: boolean;
}

interface PenaltyRowProps {
  label: string;
  points: number;
  isActive: boolean;
  isNegative: boolean;
}

function getLabelColor(theme: Theme, isActive: boolean, isNegative: boolean): string | undefined {
  if (!isActive) {
    return theme.palette.grey[400];
  }

  return isNegative ? theme.palette.intent?.error.text : theme.palette.text.primary;
}

function PenaltyRow(props: PenaltyRowProps) {
  const { label, points, isActive, isNegative } = props;

  const inactiveColor = (theme: Theme) => theme.palette.grey[400];

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Text
        variant="body2"
        sx={(theme) => ({
          color: getLabelColor(theme, isActive, isNegative),
          textDecoration: isActive ? "none" : "line-through",
        })}
      >
        {label}
      </Text>
      <Text
        semibold
        variant="body2"
        sx={(theme) => ({
          color: isActive ? theme.palette.intent?.error.text : inactiveColor(theme),
          textDecoration: isActive ? "none" : "line-through",
        })}
      >
        - {Math.abs(points)} pts
      </Text>
    </Stack>
  );
}

export function CancellationCreditPenaltySubCard(props: CancellationCreditPenaltySubCardProps) {
  const { title, pointsWithCredit, pointsWithoutCredit, hasCredit } = props;

  return (
    <Stack direction="column" spacing={3}>
      <Text bold>{title}</Text>
      <Card variant="tertiary">
        <CardContent>
          <Stack spacing={3}>
            <PenaltyRow
              isNegative={false}
              label="With a credit"
              points={pointsWithCredit}
              isActive={hasCredit}
            />
            <PenaltyRow
              isNegative
              label="Without a credit"
              points={pointsWithoutCredit}
              isActive={!hasCredit}
            />
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}
